export const ANSWER_VALUE_UNANSWERED = '-'
